import { Swiper, Navigation } from 'swiper';

export default function Search () {
    const projects = document.querySelector('.search--results-projects');
    const projectsNavs = document.querySelector('.search--results-navigation-projects');

    const projectsNavsEl = {
        'prev': projectsNavs ? projectsNavs.querySelector('.search--results-navigation--button-prev') : null,
        'next': projectsNavs ? projectsNavs.querySelector('.search--results-navigation--button-next') : null
    };

    if (projects) {
        new Swiper(projects, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 600,
            navigation: {
                prevEl: projectsNavsEl.prev,
                nextEl: projectsNavsEl.next
            },
            breakpoints: {
                580: { slidesPerView: 1.5 },
                768: { slidesPerView: 2.25 },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            }
        });
    }

    const jobs = document.querySelector('.search--results-jobs');
    const jobsNavs = document.querySelector('.search--results-navigation-jobs');

    const jobsNavsEl = {
        'prev': jobsNavs ? jobsNavs.querySelector('.search--results-navigation--button-prev') : null,
        'next': jobsNavs ? jobsNavs.querySelector('.search--results-navigation--button-next') : null
    };

    if (jobs) {
        new Swiper(jobs, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 600,
            navigation: {
                prevEl: jobsNavsEl.prev,
                nextEl: jobsNavsEl.next
            },
            breakpoints: {
                580: { slidesPerView: 1.5 },
                768: { slidesPerView: 2.25 },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            }
        });
    }

    const users = document.querySelector('.search--results-users');
    const usersNavs = document.querySelector('.search--results-navigation-users');

    const usersNavsEl = {
        'prev': usersNavs ? usersNavs.querySelector('.search--results-navigation--button-prev') : null,
        'next': usersNavs ? usersNavs.querySelector('.search--results-navigation--button-next') : null
    };

    if (users) {
        new Swiper(users, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 600,
            navigation: {
                prevEl: usersNavsEl.prev,
                nextEl: usersNavsEl.next
            },
            breakpoints: {
                580: { slidesPerView: 1.5 },
                768: { slidesPerView: 2.5 },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        });
    }
}
